/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Tlm_0Inputs */

const en_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orchestrator`)
};

const ar_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنسق`)
};

const bn_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orchestrator`)
};

const de_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestrator`)
};

const es_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orquestador`)
};

const fr_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orchestrateur`)
};

const pt_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orquestrador`)
};

const zh_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`协调器`)
};

const tr_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orkestratör`)
};

const ru_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`оркестратор`)
};

const pl_svc_automation_tlm_0 = /** @type {(inputs: Svc_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orkiestrator`)
};

/**
* | output |
* | --- |
* | "orchestrator" |
*
* @param {Svc_Automation_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_tlm_0 = /** @type {((inputs?: Svc_Automation_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_tlm_0(inputs)
	if (locale === "bn") return bn_svc_automation_tlm_0(inputs)
	if (locale === "de") return de_svc_automation_tlm_0(inputs)
	if (locale === "es") return es_svc_automation_tlm_0(inputs)
	if (locale === "fr") return fr_svc_automation_tlm_0(inputs)
	if (locale === "pt") return pt_svc_automation_tlm_0(inputs)
	if (locale === "zh") return zh_svc_automation_tlm_0(inputs)
	if (locale === "tr") return tr_svc_automation_tlm_0(inputs)
	if (locale === "ru") return ru_svc_automation_tlm_0(inputs)
	if (locale === "pl") return pl_svc_automation_tlm_0(inputs)
	return en_svc_automation_tlm_0(inputs)
});